module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticStyle: {
      "margin-bottom": "100px"
    },
    attrs: {
      "id": "helpPage"
    }
  }, [_c('h1', {
    staticClass: "helpH1",
    staticStyle: {
      "margin-top": "10px"
    }
  }, [_vm._v("座席予約表を見る")]), _vm._v(" "), _c('p', {
    staticClass: "caption cap1",
    staticStyle: {
      "color": "red"
    }
  }, [_vm._v("予約・変更・削除の締め切りは前日22時です（翌週月曜の座席予約は土曜22時までとなっております）")]), _vm._v(" "), _c('p', {
    staticClass: "caption cap1",
    staticStyle: {
      "tcolor": "red"
    }
  }, [_vm._v("上記時刻を過ぎて予約をしたい場合は、究進塾事務局(info@kyushinjuku.com)へご連絡ください")]), _vm._v(" "), _c('h2', {
    staticClass: "helpH2"
  }, [_vm._v("予約をする")]), _vm._v(" "), _c('ol', {
    staticClass: "helpOl",
    staticStyle: {
      "color": "#5B5B5B"
    }
  }, [_c('li', [_vm._v("予約したい時刻と、予約したい教室がクロスするマスをクリック")]), _vm._v(" "), _c('li', [_vm._v("「開始時間」「終了時間」「授業の種類（通常・体験・初回・短期）」「生徒のお名前」「先生のお名前」「配布物（有り・無し）」「連絡事項（必要であれば記入）」を記入")]), _vm._v(" "), _c('li', [_vm._v("「予約する」をクリック")])]), _vm._v(" "), _c('p', {
    staticClass: "caption cap2"
  }, [_vm._v("同時間帯・同教室で月末まで予約したい場合は、「月末まで毎週予約する」にチェックを入れてください")]), _vm._v(" "), _c('div', {
    staticClass: "notification"
  }, [_c('p', {
    staticClass: "caption",
    staticStyle: {
      "color": "red"
    }
  }, [_vm._v("※予約時に、「生徒のお名前」に担当生徒の氏名が表示されない場合※")]), _vm._v(" "), _c('p', {
    staticClass: "caption"
  }, [_vm._v("先生と生徒の紐づけが未完了です")]), _vm._v(" "), _c('p', {
    staticClass: "caption"
  }, [_vm._v("恐れ入りますが、究進塾事務局(info@kyushinjuku.com)へご連絡ください。また、臨時的に下記手順でご予約をお願い致します。")]), _vm._v(" "), _c('ol', {
    staticClass: "helpOl",
    staticStyle: {
      "margin-left": "40px"
    }
  }, [_c('li', [_vm._v("「授業の種類」で「短期」を選択")]), _vm._v(" "), _c('li', [_vm._v("「生徒のお名前」を “直接” 入力")])])]), _vm._v(" "), _c('h2', {
    staticClass: "helpH2"
  }, [_vm._v("予約を変更する")]), _vm._v(" "), _c('ol', {
    staticClass: "helpOl"
  }, [_c('li', [_vm._v("変更したい予約をクリック")]), _vm._v(" "), _c('li', [_vm._v("ポップアップの最下部「編集する」をクリック")]), _vm._v(" "), _c('li', [_vm._v("予約を編集")]), _vm._v(" "), _c('li', [_vm._v("「編集を完了する」をクリック")])]), _vm._v(" "), _c('h2', {
    staticClass: "helpH2"
  }, [_vm._v("予約を削除する")]), _vm._v(" "), _c('ol', {
    staticClass: "helpOl"
  }, [_c('li', [_vm._v("削除したい予約をクリック")]), _vm._v(" "), _c('li', [_vm._v("ポップアップの最下部「編集する」をクリック")]), _vm._v(" "), _c('li', [_vm._v("「予約を削除する」をクリック")])]), _vm._v(" "), _c('h1', {
    staticClass: "helpH1",
    staticStyle: {
      "margin-top": "60px"
    }
  }, [_vm._v("振替依頼")]), _vm._v(" "), _c('h2', {
    staticClass: "helpH2"
  }, [_vm._v("振替依頼をする場合")]), _vm._v(" "), _c('ol', {
    staticClass: "helpOl"
  }, [_c('li', [_vm._v("座席予約表へログイン後、画面左上の「振替を依頼する」をクリック")]), _vm._v(" "), _c('li', [_vm._v("画面の指示に従い、入力を進める")]), _vm._v(" "), _c('ol', {
    staticClass: "helpO2"
  }, [_c('li', [_vm._v("①振替を希望する授業をリストから選択")]), _vm._v(" "), _c('li', [_vm._v("②振替候補日時を選択")]), _vm._v(" "), _c('li', [_vm._v("③振替を希望する理由を入力")]), _vm._v(" "), _c('li', [_vm._v("（講師のみ、④振替後の授業の情報を入力）")])]), _vm._v(" "), _c('li', [_vm._v("入力項目を確認し、「振替依頼をする」ボタンをクリック")]), _vm._v(" "), _c('li', [_vm._v("または、「戻って修正する」ボタンをクリック")]), _vm._v(" "), _c('li', [_vm._v("完了画面を確認し、「座席表トップへ」をクリック")])]), _vm._v(" "), _c('div', {
    staticClass: "messagetext"
  }, [_c('span', {
    staticClass: "box-title"
  }, [_vm._v("振替依頼をしたあとは・・・")]), _vm._v(" "), _c('p', [_vm._v("24時間以内に振替の承認・不承認の結果がメールで届きます。"), _c('br'), _vm._v("\n\t\t\t承認された場合は、そのまま振替後の日時に教室にお越しください。"), _c('br'), _vm._v("\n\t\t\t不承認された場合は、承認者から別の振替候補日時が提案されますので、再度振替依頼を行ってください。")])]), _vm._v(" "), _c('h2', {
    staticClass: "helpH2"
  }, [_vm._v("振替依頼をされた場合")]), _vm._v(" "), _c('ol', {
    staticClass: "helpOl"
  }, [_c('li', [_vm._v("「〇〇様からの授業振替依頼が届きました」または「〇〇先生からの授業振替依頼が届きました」という件名のメールが届く")]), _vm._v(" "), _c('li', [_vm._v("メール内のURLをクリック")]), _vm._v(" "), _c('li', [_vm._v("画面の指示に従い、入力を進める")]), _vm._v(" "), _c('ol', [_c('li', {
    staticStyle: {
      "font-weight": "bold",
      "margin-top": "5px"
    }
  }, [_vm._v("【承認する場合】")]), _vm._v(" "), _c('ol', {
    staticClass: "helpO2 ol-second-level"
  }, [_c('li', [_vm._v("①振替候補日時からご都合の良い日時を選択")]), _vm._v(" "), _c('li', [_vm._v("　（講師のみ振替後の授業の情報を指定）")]), _vm._v(" "), _c('li', [_vm._v("②振替後の授業を予約する座席を選択")]), _vm._v(" "), _c('li', [_vm._v("③入力項目を確認し、「振替を確定する」をクリック")]), _vm._v(" "), _c('li', [_vm._v("　または、「戻って修正する」ボタンをクリック")]), _vm._v(" "), _c('li', [_vm._v("④完了画面を確認し、「座席表トップへ」をクリック")])]), _c('br'), _vm._v(" "), _c('li', {
    staticStyle: {
      "font-weight": "bold",
      "margin-top": "5px"
    }
  }, [_vm._v("【不承認する場合】")]), _vm._v(" "), _c('ol', {
    staticClass: "helpO2 ol-second-level"
  }, [_c('li', [_vm._v("①「振替を不承認する」にチェックを入れる")]), _vm._v(" "), _c('li', [_vm._v("　（講師のみ振替後の授業の情報を指定）")]), _vm._v(" "), _c('li', [_vm._v("②他の振替候補日時を入力")]), _vm._v(" "), _c('li', [_vm._v("③入力項目を確認し、「振替依頼を不承認する」をクリック")]), _vm._v(" "), _c('li', [_vm._v("　または、「戻って修正する」ボタンをクリック")]), _vm._v(" "), _c('li', [_vm._v("④完了画面を確認し、「座席表」をクリック")])])])]), _vm._v(" "), _c('div', {
    staticClass: "messagetext"
  }, [_c('span', {
    staticClass: "box-title"
  }, [_vm._v("承認/不承認をしたあとは・・・")]), _vm._v("\n\t\t\t承認・不承認の結果がメールで依頼者に届きます。"), _c('br'), _vm._v("\n\t\t\t承認した場合は、そのまま振替後の日時に教室にお越しください。"), _c('br'), _vm._v("\n\t\t\t不承認した場合は、依頼者から別の振替候補日時が提案されますので、再度承認/不承認を行ってください。\n\t")]), _vm._v(" "), _c('h1', {
    staticClass: "helpH1"
  }, [_vm._v("ヘルプ")]), _vm._v(" "), _c('p', {
    staticClass: "caption cap1"
  }, [_vm._v("本画面です")]), _vm._v(" "), _c('h1', {
    staticClass: "helpH1"
  }, [_vm._v("ユーザ情報")]), _vm._v(" "), _c('p', {
    staticClass: "caption cap1"
  }, [_vm._v("パスワードおよびユーザ名（ID）の変更が出来ます")]), _vm._v(" "), _c('div', {
    staticClass: "notification"
  }, [_c('p', {
    staticClass: "caption",
    staticStyle: {
      "color": "red"
    }
  }, [_vm._v("※ご注意ください※")]), _vm._v(" "), _c('p', {
    staticClass: "caption"
  }, [_vm._v("初回設定以外のパスワードに変更される場合は、"), _c('span', {
    staticStyle: {
      "color": "red"
    }
  }, [_vm._v("事務局では変更内容を確認出来ません")])]), _vm._v(" "), _c('p', {
    staticClass: "caption"
  }, [_vm._v("変更後のパスワードは各個人で保管いただきますようお願い申し上げます")])]), _vm._v(" "), _c('h1', {
    staticClass: "helpH1",
    staticStyle: {
      "margin-top": "60px"
    }
  }, [_vm._v("ログアウト")]), _vm._v(" "), _c('p', {
    staticClass: "cap1",
    staticStyle: {
      "text-align": "left",
      "margin-left": "40px",
      "font-size": "14px",
      "color": "#5B5B5B",
      "margin-top": "10px"
    }
  }, [_vm._v("ログアウトが出来ます")]), _vm._v(" "), _c('p', {
    staticClass: "cap1",
    staticStyle: {
      "text-align": "left",
      "margin-left": "40px",
      "font-size": "14px",
      "color": "red",
      "margin-bottom": "100px"
    }
  }, [_vm._v("究進塾のPCで座席予約表を操作される場合は、セキュリティ上必ずログアウトしていただきますようお願い致します")])])
}]}
module.exports.render._withStripped = true
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
     require("vue-hot-reload-api").rerender("data-v-11d18f27", module.exports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-11d18f27"}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/HelpPage/SimpleHelpPage.vue
// module id = 676
// module chunks = 0